import { gql } from "@apollo/client";
import { apolloClient } from "../../services/apolloclient";

export const GET_GPHERO = gql`
  query MyQuery {
  gpExperiencePage {
    hero {
      contentItems {
        ... on LeftSection {
          enabled
          headLine
          tagLine
          cTA1 {
              text
              url
            }
          cTA2 {
            text
            url
          }
          isCTA2
          isCTA1
        }
        ... on RightSection {
            title
            openDays
            openTimes
            enabled
          }
        ... on BackGroundSection {
          media {
            urls
          }
          isVideo
          enabled
        }
      }
    }
  }
}
`;

export async function fetchHero() {
  const response = await apolloClient.query({
    query: GET_GPHERO,
    fetchPolicy: "network-only",
  });

  return response.data;
}
